import { Controller } from "@hotwired/stimulus"
import { ApiClient } from "../utils/api"
import { DomHelper } from "../utils/dom"

export default class extends Controller {
  static targets = ["startTime", "endTime", "menuSelect"]

  connect() {
    this.menuSelectTarget.addEventListener('change', this.updateEndTime.bind(this))
    this.startTimeTarget.addEventListener('change', this.updateEndTime.bind(this))
  }

  updateEndTime() {
    const menuId = this.menuSelectTarget.value
    if (!menuId || !this.startTimeTarget.value) return

    const menuOption = this.menuSelectTarget.selectedOptions[0]
    const durationText = menuOption.textContent.match(/\((\d+)分\)/)

    if (durationText) {
      const duration = parseInt(durationText[1])
      const startTimeValue = this.startTimeTarget.value

      const [datePart, timePart] = startTimeValue.split('T')
      const [hours, minutes] = timePart.split(':').map(Number)

      const totalMinutes = hours * 60 + minutes + duration
      const endHours = Math.floor(totalMinutes / 60)
      const endMinutes = totalMinutes % 60

      const endTimeString = `${datePart}T${DomHelper.padTime(endHours)}:${DomHelper.padTime(endMinutes)}`
      this.endTimeTarget.value = endTimeString
    }
  }

  async loadCustomerMenus(event) {
    const customerId = event.detail.id
    try {
      const response = await ApiClient.get('/admin/reservations/available_menus', { customer_id: customerId })
      const menus = await response.json()

      this.menuSelectTarget.innerHTML = '<option value="">メニューを選択</option>'
      menus.forEach(menu => {
        const option = document.createElement('option')
        option.value = menu.id
        option.textContent = `${menu.name} (${menu.duration_minutes}分)`
        if (!menu.available) {
          option.disabled = true
          option.textContent += ' - セッション不足'
        }
        this.menuSelectTarget.appendChild(option)
      })
    } catch (error) {
      console.error('Error loading menus:', error)
    }
  }

  async submit(event) {
    event.preventDefault()

    const form = event.target
    const formData = new FormData(form)

    try {
      const response = await ApiClient.post(form.action, formData)

      if (!response.ok) {
        const errorData = await response.json()
        const errorMessage = errorData.errors ? errorData.errors.join(', ') : 'エラーが発生しました'

        if (window.showToast) {
          window.showToast(errorMessage, 'error')
        } else {
          console.error(errorMessage)
        }
        return
      }

      // JSONレスポンスの取得を試みる（失敗してもOK）
      let data = null
      try {
        data = await response.json()
      } catch (jsonError) {
        // JSON parseエラーは無視
      }

      // モーダルを閉じる
      const modal = form.closest('.modal')

      if (modal) {
        try {
          // 動的にBootstrapをインポート
          const bootstrap = await import("bootstrap")
          const Modal = bootstrap.Modal

          const bootstrapModal = Modal.getInstance(modal)

          if (bootstrapModal) {
            bootstrapModal.hide()
          }
        } catch (modalError) {
          console.error('Modal error:', modalError)
        }
      }

      // 成功メッセージを表示してからリロード
      const successMessage = data?.message || '予約を作成しました'
      if (window.showToast) {
        window.showToast(successMessage, 'success')
        setTimeout(() => window.location.reload(), 500)
      } else {
        window.location.reload()
      }
    } catch (error) {
      if (window.showToast) {
        window.showToast('通信エラーが発生しました', 'error')
      } else {
        console.error('Form submission error:', error)
      }
    }
  }
}
